
import React from 'react'
import './search-box.css'


const SearchBox = ({ group, searchHandler }) => {

    return (
        <div className='search-box'>
            <input
                type='search'
                placeholder="أبحث هنا عن السورة "
                onChange={searchHandler}
            />
            {group.length === 0 ?
                <div className='alert1'>لا يوجد سوره هنا بهذا الاسم </div> : ''}
        </div>
    )
}


export default SearchBox;